import React from 'react'

const Portfolio = () => {
  return (
    <div class="mb-5">
      <div class="d-flex justify-content-center">
        <h2>Portafolio</h2>
      </div>
      <div class="row">
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">InternalWork
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fa fa-cube"></i>
                </a>
              </h5>
              <p class="card-text">Plataforma interna de una empresa que busca concretamente que sus empleados puedan postular a cargos internos  y poder escalar dentro de su compañía.</p>
              <a href="https://github.com/camilaOlivaresR/internal-work" class="btn border">Github</a>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">Portafolio de Fotos
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fa fa-cube"></i>
                </a>
              </h5>
              <p class="card-text">Karina pide desarrollar una aplicación simple para que los usuarios puedan ver sus fotografías y comentarlas.</p>
              <a href="https://github.com/camilaOlivaresR/ProyectoPortafolioFotos" target="_blank" v class="btn border">Github</a>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">The Rial News
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fa fa-cube"></i>
                </a>
              </h5>
              <p class="card-text">
                Nuestro cliente, busca lanzar su nuevo sitio de noticias llamado “TheRialNews” donde en forma satírica informa a sus usuarios de actualidad.</p>
              <a href="https://github.com/camilaOlivaresR/TheRialNews" target="_blank" rel="noreferrer" class="btn border">Github</a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">Catalogo productos
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fa fa-cube"></i>
                </a>
              </h5>
              <p class="card-text">Catálogo de productos donde el usuario pueda revisar los productos que se encuentran en él y poder determinar entre muchas opciones, los productos tendrán categorías asociadas para poder ordenarlos en un futuro.</p>
              <a href="https://github.com/camilaOlivaresR/CatalogoRoR" target="_blank" rel="noreferrer" class="btn border ">Github</a>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">Medical Center
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fa fa-cube"></i>
                </a>
              </h5>
              <p class="card-text">Un cliente ha pedido desarrollar una aplicación para poder llevar un registro de los tratamientos que le ha asignado a un paciente..</p>
              <a href="https://github.com/camilaOlivaresR/MedicalCenter-RoR" target="_blank" rel="noreferrer" class="btn border">Github</a>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">Movie Blog
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fa fa-cube"></i>
                </a>
              </h5>
              <p class="card-text">Blog de peliculas ,series y documentales en Ruby on Rails</p>
              <a href="https://github.com/camilaOlivaresR/MovieBlog_Ror2024" target="_blank" rel="noreferrer" class="btn border">Github</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">Web Responsiva
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fab fa-wordpress"></i>
                </a>
              </h5>
              <p class="card-text">Web responsiva desarrollada en WordPress.</p>
              <a href="https://anis88.com/" class="btn btn border" target="_blank" rel="noreferrer" >Web responsiva</a>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body">
              <h5 class="card-title">Red Social Deporte
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fab fa-js"></i>
                </a>
              </h5>
              <p class="card-text">Sport Fem es una red social diseñada para mujeres que realizan deportes al aire libre y les gustaría conectar con otras mujeres para realizar estas actividades en conjunto y crear comunidad .</p>
              <a href="https://github.com/camilaOlivaresR/SCL018-social-network/tree/cami" target="_blank" rel="noreferrer" class="btn btn border">Github</a>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2" >
          <div class="card h-100">
            {/* <img src="..." class="card-img-top" alt="..." /> */}
            <div class="card-body" >
              <h5 class="card-title">Vegan Queen
                <a
                  data-mdb-ripple-init
                  class="btn btn-link btn-floating btn-lg text-body m-1"
                  href="#!"
                  role="button"
                  data-mdb-ripple-color="dark"
                  target="_blank"
                ><i class="fab fa-js"></i>
                </a>
              </h5>
              <p class="card-text">
                aplicación web para un restaurante con necesidad de poder agilizar la toma, gestión y entrega de pedidos, esta diseñada para usarse en dispositivos tipo tablet.
              </p>
              <a href="https://github.com/camilaOlivaresR/SCL018-burger-queen" target="_blank" rel="noreferrer" class="btn btn border">Github</a>
            </div>
          </div>
        </div>
      </div>
    </div>


  )
}

export default Portfolio